import { render, staticRenderFns } from "./ypsdk.vue?vue&type=template&id=4a378fee&scoped=true&"
import script from "./ypsdk.vue?vue&type=script&lang=js&"
export * from "./ypsdk.vue?vue&type=script&lang=js&"
import style0 from "./ypsdk.vue?vue&type=style&index=0&id=4a378fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a378fee",
  null
  
)

export default component.exports